import { ref, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export function useAppSidebar() {
  const router = useRouter()
  const mobileSidebarOpen = ref(false)
  const sidebarCollapsed = ref(false)

  watch(sidebarCollapsed, (newValue) => {
    localStorage.setItem('sidebarCollapsed', String(newValue))
  })

  const toggleMobileSidebar = () => {
    mobileSidebarOpen.value = !mobileSidebarOpen.value
  }

  const closeMobileSidebar = () => {
    mobileSidebarOpen.value = false
  }

  const toggleSidebar = () => {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  const handleRouteChange = () => {
    closeMobileSidebar()
  }

  onMounted(() => {
    const savedState = localStorage.getItem('sidebarCollapsed')
    if (savedState !== null) {
      sidebarCollapsed.value = savedState === 'true'
    }
    router.afterEach(handleRouteChange)
  })

  return {
    mobileSidebarOpen,
    sidebarCollapsed,
    toggleMobileSidebar,
    closeMobileSidebar,
    toggleSidebar
  }
}
